import { ToggleButtonGroup, ToggleButton } from '@evaneos/b2b-ui';
import { Link, useLocation } from 'react-router-dom';

import { setEntryPoint } from '../analytics/sessionStorage-utilities';

const toggleSx = {
    color: 'text.primary',
    '&.Mui-selected': {
        backgroundColor: 'primary.main',
        color: 'primary.contrastText',
    },
    '&.Mui-selected:hover': {
        backgroundColor: 'primary.dark',
        color: 'primary.contrastText',
    },
    textTransform: 'none',
};

type NavigationToggleProps = {
    inboxCount: number;
    selected: 'inbox' | 'pipeline' | 'todo';
};

export const NavigationToggle = ({ inboxCount, selected }: NavigationToggleProps) => {
    const location = useLocation();
    return (
        <ToggleButtonGroup
            color="primary"
            value={selected}
            size="small"
            exclusive
            aria-label="Platform"
        >
            <ToggleButton
                data-testid="link-inbox"
                component={Link}
                to={{
                    pathname: '/homepage',
                    search: location.search,
                }}
                onClick={() => {
                    if (selected !== 'inbox') {
                        setEntryPoint('inbox_button');
                    }
                }}
                disableRipple
                sx={toggleSx}
                value="inbox"
            >
                Inbox ({inboxCount ? inboxCount : '0'})
            </ToggleButton>
            <ToggleButton
                component={Link}
                to={{ pathname: '/process/sales', search: location.search }}
                disableRipple
                sx={toggleSx}
                value="pipeline"
            >
                Pipeline
            </ToggleButton>
            <ToggleButton
                component={Link}
                to={{ pathname: '/todo/today', search: location.search }}
                disableRipple
                sx={toggleSx}
                value="todo"
            >
                To Do
            </ToggleButton>
        </ToggleButtonGroup>
    );
};
